import { IOrgMember } from '@/types/IOrgMember';
import { Box, IconButton, Menu, MenuButton, MenuItem, MenuList, Stack, Td, Text, Tr } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { FiTrash2 } from 'react-icons/fi';
import { VscKey } from 'react-icons/vsc';
import MemberRole from './components/member.role.component';

interface IProps {
	member: IOrgMember;
	onRemoveMember: (memberId: string) => Promise<void>;
}

export default function Member(props: IProps) {
	const { t } = useTranslation();

	return (
		<Tr key={props.member.id}>
			<Td>
				<Stack textAlign="left">
					<Text fontWeight="500" fontSize="md">
						{props.member.email}
					</Text>
					<Box>
						{props.member.roles.map((role) => (
							<MemberRole key={role} role={role} />
						))}
					</Box>
				</Stack>
			</Td>

			<Td isNumeric>
				<Menu placement="bottom-end">
					<MenuButton
						as={IconButton}
						variant="ghost"
						aria-label="edit"
						icon={<BiDotsHorizontalRounded />}
						size="md"
					></MenuButton>
					<MenuList>
						<MenuItem icon={<FiTrash2 />} onClick={() => props.onRemoveMember(props.member.id)}>
							{t('Remove')}
						</MenuItem>
						<MenuItem icon={<VscKey />} isDisabled>
							{t('Change role')}
						</MenuItem>
					</MenuList>
				</Menu>
			</Td>
		</Tr>
	);
}
